import { UPTAKE_REPORT_DATA_RECIVED, COLUMN_SORTED } from "./reportingActions";

export default function reporting(state = { sort: {} }, action) {
    if (action.type === UPTAKE_REPORT_DATA_RECIVED) {
        return Object.assign({}, state, { uptake: action.payload });
    }

    if (action.type == COLUMN_SORTED) {
        return Object.assign({}, state, { sort: action.payload});
    }

    return state;
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/uptake/reportingReducer.js
 **/